import { dataCutSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCutSolid = /*#__PURE__*/createIcon(dataCutSolid)
export default IconCutSolid
